<template>
    <section class="p-0" id="portfolio">
      <div id="portfolio-header" class="masthead text-white text-center">
        <div class="container h-100 d-flex justify-content-center">
          <div class="my-auto">
            <hr class="light" data-aos="fade-right">
            <h1 class="text-white">
              CASOS DE ÉXITO
            </h1>
            <hr class="light" data-aos="fade-left">
          </div>
       </div>
      </div>
      <div class="container">
            <div class="row text-center">
                <div class="col-xl-12">
                    <h2 class="">&nbsp;</h2>
                </div>
            </div>
      </div>
      <div class="container">
            <div class="row text-center">
                <div class="col-xl-12">
                    <h2 class="">Proyectos memorables con nuestros clientes</h2>
                </div>
            </div>
      </div>
    </section>
</template>
<script>
export default {
    name: 'Portfolio',
    components: {
    }
}
</script>
<style scoped>
    .img-center {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/portfolio/Portfolio.vue